(() => {
  // Mobile drawer
  const drawer = document.querySelector('[data-hp-drawer]');
  const backdrop = document.querySelector('[data-hp-drawer-backdrop]');
  const openMenu = document.querySelector('[data-hp-menu-toggle]');
  const closeMenu = document.querySelector('[data-hp-menu-close]');

  const setDrawer = (open) => {
    if (!drawer || !backdrop || !openMenu) return;
    drawer.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    openMenu.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('hp-drawer-open', open);
  };

  openMenu?.addEventListener('click', () => setDrawer(true));
  closeMenu?.addEventListener('click', () => setDrawer(false));
  backdrop?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', () => setDrawer(false));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setDrawer(false);
  });

  // Product gallery
  document.querySelectorAll('[data-hp-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.hp-product-gallery');
      const main = gallery?.querySelector('.hp-product-main-image');
      if (!gallery || !main) return;

      main.src = thumb.dataset.src;
      main.removeAttribute('srcset');

      gallery.querySelectorAll('[data-hp-thumb]').forEach((item) => {
        item.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });


  // Product gallery: one large image, arrows, swipe and autoplay
  document.querySelectorAll('[data-hp-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];

    if (!track || !viewport || slides.length < 1) return;

    let current = 0;
    let timer = null;
    let startX = 0;
    let deltaX = 0;
    let dragging = false;

    const goTo = (index, resetTimer = true) => {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });

      if (resetTimer) startAutoplay();
    };

    const startAutoplay = () => {
      clearInterval(timer);
      if (slides.length < 2) return;
      timer = setInterval(() => goTo(current + 1, false), 4500);
    };

    const stopAutoplay = () => {
      clearInterval(timer);
      timer = null;
    };

    previous?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryDot)));
    });

    viewport.addEventListener('pointerdown', (event) => {
      dragging = true;
      startX = event.clientX;
      deltaX = 0;
      viewport.classList.add('is-dragging');
      stopAutoplay();
      try { viewport.setPointerCapture(event.pointerId); } catch {}
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      deltaX = event.clientX - startX;
    });

    const finishSwipe = () => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');

      const threshold = Math.max(45, viewport.clientWidth * 0.12);

      if (deltaX <= -threshold) {
        goTo(current + 1);
      } else if (deltaX >= threshold) {
        goTo(current - 1);
      } else {
        goTo(current);
      }
    };

    viewport.addEventListener('pointerup', finishSwipe);
    viewport.addEventListener('pointercancel', finishSwipe);
    viewport.addEventListener('pointerleave', finishSwipe);

    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', startAutoplay);

    gallery._hpGoTo = (index) => goTo(index);
    goTo(0, false);
    startAutoplay();
  });


  // Product variant picker: visual color + size controls.
  document.querySelectorAll('[data-hp-variant-picker]').forEach((picker) => {
    const form = picker.closest('.hp-product-form');
    const variantInput = form?.querySelector('[data-hp-variant]');
    const dataScript = form?.querySelector('[data-hp-variants]');
    if (!form || !variantInput || !dataScript) return;

    let variants = [];
    try {
      variants = JSON.parse(dataScript.textContent || '[]');
    } catch {
      return;
    }
    if (!variants.length) return;

    const colors = [...picker.querySelectorAll('[data-color-option]')];
    const sizes = [...picker.querySelectorAll('[data-size-option]')];
    const unavailable = picker.querySelector('[data-variant-unavailable]');
    const info = form.closest('.hp-product-info');
    const currentPriceEl = info?.querySelector('[data-current-price]');
    const comparePriceEl = info?.querySelector('[data-compare-price]');
    const discountEl = info?.querySelector('[data-price-discount]');
    const gallery = document.querySelector('[data-hp-gallery]');

    let selectedColor = variants[0].color;
    let selectedSize = variants[0].size;

    const findVariant = (color, size) =>
      variants.find((v) => v.color === color && v.size === size);

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'EUR';
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'it-IT',
          { style: 'currency', currency }
        ).format(Number(cents) / 100);
      } catch {
        return `€${(Number(cents) / 100).toFixed(2).replace('.', ',')}`;
      }
    };

    const updatePrice = (variant) => {
      if (currentPriceEl) {
        currentPriceEl.textContent = formatMoney(variant.price);
      }

      const hasDiscount =
        Number(variant.compareAtPrice || 0) > Number(variant.price || 0);

      if (comparePriceEl) {
        comparePriceEl.hidden = !hasDiscount;
        if (hasDiscount) {
          comparePriceEl.textContent = formatMoney(variant.compareAtPrice);
        }
      }

      if (discountEl) {
        discountEl.hidden = !hasDiscount;
        if (hasDiscount) discountEl.textContent = '-50%';
      }
    };

    const updateBundles = (variant) => {
      form.querySelectorAll('[data-bundle-option]').forEach((option) => {
        const qty = Number(option.dataset.quantity || 1);
        const currentTotal = Number(variant.price) * qty;
        const compareTotal = Number(variant.compareAtPrice || 0) * qty;

        option.dataset.unitPrice = String(variant.price);
        option.dataset.unitCompare = String(variant.compareAtPrice || 0);

        const totalEl = option.querySelector('[data-bundle-total]');
        const compareEl = option.querySelector('[data-bundle-compare]');
        const discountEl = option.querySelector('.hp-bundle-discount');

        if (totalEl) totalEl.textContent = formatMoney(currentTotal);

        if (compareEl) {
          compareEl.hidden = !(compareTotal > currentTotal);
          if (compareTotal > currentTotal) {
            compareEl.textContent = formatMoney(compareTotal);
          }
        }

        if (discountEl) {
          discountEl.hidden = !(compareTotal > currentTotal);
        }
      });
    };

    const updateGallery = (color) => {
      if (!gallery || typeof gallery._hpGoTo !== 'function') return;
      // Current product gallery: first image is brown house, second image is gray house.
      gallery._hpGoTo(color === 'gray' ? 1 : 0);
    };

    const render = () => {
      const variant = findVariant(selectedColor, selectedSize);

      colors.forEach((button) => {
        const active = button.dataset.colorOption === selectedColor;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      sizes.forEach((button) => {
        const candidate = findVariant(selectedColor, button.dataset.sizeOption);
        const active = button.dataset.sizeOption === selectedSize;
        button.classList.toggle('is-selected', active);
        button.classList.toggle('is-disabled', !candidate);
        button.disabled = !candidate;
        button.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (!variant) {
        if (unavailable) unavailable.hidden = false;
        return;
      }

      if (unavailable) unavailable.hidden = !!variant.available;
      variantInput.value = variant.id;
      updatePrice(variant);
      updateBundles(variant);
      updateGallery(selectedColor);
    };

    colors.forEach((button) => {
      button.addEventListener('click', () => {
        selectedColor = button.dataset.colorOption;

        if (!findVariant(selectedColor, selectedSize)) {
          const fallback = ['S', 'M', 'L']
            .map((size) => findVariant(selectedColor, size))
            .find(Boolean);
          if (fallback) selectedSize = fallback.size;
        }
        render();
      });
    });

    sizes.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        selectedSize = button.dataset.sizeOption;
        render();
      });
    });

    const initial = variants.find((v) => v.available) || variants[0];
    selectedColor = initial.color;
    selectedSize = initial.size;
    render();
  });

  // Product bundle selector: only BUY ONE / BUY TWO.
  document.querySelectorAll('.hp-product-form').forEach((form) => {
    const options = [...form.querySelectorAll('[data-bundle-option]')];
    const qtyInput = form.querySelector('[data-hp-quantity]');

    const refreshQuantity = () => {
      const selected =
        options.find((option) => option.classList.contains('is-selected')) ||
        options[0];

      if (selected && qtyInput) {
        qtyInput.value = selected.dataset.quantity || '1';
      }
    };

    options.forEach((option) => {
      option.addEventListener('click', () => {
        options.forEach((item) => item.classList.remove('is-selected'));
        option.classList.add('is-selected');
        refreshQuantity();
      });
    });

    refreshQuantity();
  });

  // Reviews slider
  document.querySelectorAll('.hp-reviews').forEach((section) => {
    const track = section.querySelector('[data-review-track]');
    const dots = [...section.querySelectorAll('[data-review-dot]')];
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');

    if (!track || !dots.length) return;

    let current = 0;

    const goTo = (index) => {
      current = (index + dots.length) % dots.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    };

    previous?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.reviewDot)));
    });
  });

  // Cart quantity controls: update the real Shopify cart, then reload
  // so totals, prices and shipping are rendered from Shopify's server state.
  document.querySelectorAll('[data-hp-cart]').forEach((cart) => {
    const updateLine = async (row, quantity) => {
      const key = row?.dataset.cartLine;
      if (!key) return;

      const buttons = [...row.querySelectorAll('button')];
      buttons.forEach((button) => { button.disabled = true; });

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, Number(quantity) || 0)
          })
        });

        if (!response.ok) {
          throw new Error(`Cart update failed: ${response.status}`);
        }

        await response.json();
        window.location.reload();
      } catch (error) {
        console.error(error);
        buttons.forEach((button) => { button.disabled = false; });
      }
    };

    cart.addEventListener('click', (event) => {
      const increase = event.target.closest('[data-cart-increase]');
      const decrease = event.target.closest('[data-cart-decrease]');
      const remove = event.target.closest('[data-cart-remove]');
      const row = event.target.closest('[data-cart-line]');
      const input = row?.querySelector('.hp-cart-qty');

      if (!row || !input) return;

      const current = Number(input.value || 0);

      if (increase) {
        event.preventDefault();
        updateLine(row, current + 1);
      } else if (decrease) {
        event.preventDefault();
        updateLine(row, current - 1);
      } else if (remove) {
        event.preventDefault();
        updateLine(row, 0);
      }
    });

    cart.addEventListener('change', (event) => {
      const input = event.target.closest('.hp-cart-qty');
      if (!input) return;
      updateLine(input.closest('[data-cart-line]'), input.value);
    });
  });


})();
